import { Injectable, Inject } from '@angular/core';
import { WsPacketService } from '../ws-packet/ws-packet.service';
import { WebsocketConfigService } from '../data-studio-ws-config.service';
import { Observable, Subject, Observer } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class WebsocketService {
	constructor(
		private wsPacketService: WsPacketService,
		@Inject(WebsocketConfigService) private WsConfig
	) { }
	private subject: Subject<MessageEvent>;
	public connect(): Subject<MessageEvent> {
		// if (!this.subject) {
			this.subject = this.create();
		// }
		return this.subject;
	}

	private create(): Subject<MessageEvent> {

    let ws = new WebSocket(this.WsConfig.url);
    ws.onopen = () => {
      ws.send(JSON.stringify(this.wsPacketService.getAuthenticatePackets()));
    };

		let observable = new Observable(

			(obs: Observer<MessageEvent>) => {
				ws.onmessage = obs.next.bind(obs);
				ws.onerror = obs.error.bind(obs);
				ws.onclose = obs.complete.bind(obs);
				return ws.close.bind(ws);
			});
		let observer = {
			next: (data: Object) => {
				if (ws.readyState === WebSocket.OPEN) {
					return ws.send(JSON.stringify(data));
				}
			},
			complete: () => {
				if (ws.readyState === WebSocket.OPEN) {
					this.subject = null;
					return ws.close();
				}
			}
		};
		return Subject.create(observer, observable);
	}

}
